import { call, put, takeEvery } from "redux-saga/effects";
import axios from "axios";

// Login Redux States
import { LOGIN_USER, LOGOUT_USER ,CLEAR_API_ERROR } from "./actionTypes";
import { apiError, loginSuccess, logoutUserSuccess,clearApiError } from "./actions";
import { useNavigate } from "react-router-dom";

//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper";
import {
  postFakeLogin,
  postJwtLogin,
} from "../../../helpers/fakebackend_helper";

const fireBaseBackend = getFirebaseBackend();

// function* loginUser({ payload: { user, history } }) {
//   try {
//     if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
//       const response = yield call(
//         fireBaseBackend.loginUser,
//         user.email,
//         user.password
//       );
//       yield put(loginSuccess(response));
//     } else if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
//       const response = yield call(postJwtLogin, {
//         email: user.email,
//         password: user.password,
//       });
//       localStorage.setItem("authUser", JSON.stringify(response));
//       yield put(loginSuccess(response));
//     } else if (process.env.REACT_APP_DEFAULTAUTH === "fake") {
//       const response = yield call(postFakeLogin, {
//         email: user.email,
//         password: user.password,
//       });
//       localStorage.setItem("authUser", JSON.stringify(response));
//       yield put(loginSuccess(response));
//     }
//     history("/dashboard");
//   } catch (error) {
//     yield put(apiError(error));
//   }
// }
/**
 * Generate a 16-character random token
 * @returns {string} - A randomly generated string
 */
const generateRandomToken = () => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let token = '';
  for (let i = 0; i < 16; i++) {
    token += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return token;
};
function maskToken(token) {
  // Mask all but the first and last 4 characters of the token
  const maskedToken = token.substring(0, 1) + '************' + token.slice(-1);
  return maskedToken;
}

// function* loginUser({ payload: { user, history } }) {
//   try {
//     // API request to real login endpoint
//     const response = yield call(axios.post, "https://alpha.attestaai.com/alpha/login", {
//       username: user.email,
//       password: user.password,
//     });

//     if (response.message === "login successful!") {

//       const token = generateRandomToken();
//       const maskedToken = maskToken(token);


//       localStorage.setItem("name",response.user.username);
//       localStorage.setItem("userid",response.user.userid);
//       localStorage.setItem("token", maskedToken);  // Store random token
     
//       // Successful login, dispatch loginSuccess
//       yield put(loginSuccess(response));
//       yield put(clearApiError()); // Clear error on success
//       history("/upload"); // Redirect to dashboard
//     } else {
//       // Handle error if login fails
//       // yield put(apiError("Invalid credentials"));
//       // loginUser();
//       yield put(apiError(response.error || "Invalid credentials"));

//     }
//   } catch (error) {
//     // Handle API error
//     const message =
//       (error.response && error.response && error.response.error) ||
//       error.message ||
//       "User Name or Password Incorrect";
//     yield put(apiError(message)); 
//     // yield put(apiError(error.response.message || "Login failed"));
//   }
  
  
// }

function* loginUser({ payload: { user, history } }) {
  try {
    // Static credentials for login
    const staticUser = {
      email: "user@mailinator.com",
      password: "User@123",
      name: "User",
      username: "user",
    };

    // Check if provided credentials match static credentials
    if (user.email === staticUser.email && user.password === staticUser.password) {
      const token = generateRandomToken();
      const maskedToken = maskToken(token);

      localStorage.setItem("name", staticUser.name);
      localStorage.setItem("username", staticUser.username);
      localStorage.setItem("token", maskedToken);  // Store random token

      // Successful login, dispatch loginSuccess
      yield put(loginSuccess(staticUser));
      yield put(clearApiError()); // Clear error on success
      history("/dashboard"); // Redirect to dashboard
    } else {
      // Handle invalid credentials
      yield put(apiError("Invalid credentials"));
    }
  } catch (error) {
    // Handle unexpected errors
    const message = error.message || "An error occurred during login";
    yield put(apiError(message));
  }
}


function* logoutUser() {
  try {
    sessionStorage.clear();
    localStorage.removeItem("name");
    localStorage.removeItem("username");
    localStorage.removeItem("token");
    localStorage.removeItem("secretKey");


    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const response = yield call(fireBaseBackend.logout);
      yield put(logoutUserSuccess(LOGOUT_USER, response));
    } else {
      yield put(logoutUserSuccess(LOGOUT_USER, true));
    }
  } catch (error) {
    yield put(apiError(LOGOUT_USER, error));
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser);

  yield takeEvery(LOGOUT_USER, logoutUser);
}

export default authSaga;
